import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/app.jsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/app/global.css");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/src/shared/redux/providers.jsx");
